const constants = {
  title: "Recomendaciones",
};

export default constants;
